import { USER_ROLE } from 'api/users/users.model';

export type Hello = string;

export type UserLoginViewModel = {
  username: string;
  password?: string;
};

export type LoginResponseModel = {
  token: string;
};

export type FullIdentityLoginResponseModel = {
  taskId: string;
};

export type LoginErrorModel = {
  statusCode: LOGIN_ERROR_STATUS;
  timestamp: string;
};

export type LoginTaskResponseModel = {
  status: LOGIN_TASK_STATUS;
  token: string;
};

export type RefreshTokenResponseModel = {
  token: string;
};

export type CurrentUserResponseModel = {
  department: string;
  email: string;
  firstName: string;
  id: string;
  isActive: boolean;
  lastName: string;
  passwordUpdatedAt: string;
  phoneNumber: string;
  role: USER_ROLE;
  username: string;
};

export enum SETTINGS_KEY {
  DOCUMENT_PREVIEW_URL = 'DOCUMENT_PREVIEW_URL',
}

export type SettingsItemModel = {
  key: SETTINGS_KEY;
  value: any;
};

export enum UTILITY_QUERY {
  GET_SETTINGS = 'GET_SETTINGS',
  TRACK_TASK_ID = 'TRACK_TASK_ID',
  ME = 'ME',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
}

export enum LOGIN_ERROR_STATUS {
  NOT_FOUND = 'NOT_FOUND',
  CNODE_NOT_AVAILABLE = 'CNODE_NOT_AVAILABLE',
  FORBIDDEN = 'FORBIDDEN',
}

export enum LOGIN_TASK_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  ERROR = 'ERROR',
  INVALID_TASK_ID = 'INVALID_TASK_ID',
  SUCCESS = 'SUCCESS',
}
